import React, { useState } from "react";

import { IconDownload, IconSendEmail } from "../../../../common/icons/index";

const columns = [
  "Driver",
  "Total Loads",
  "Legs",
  "Pull Container",
  "Deliver Loads",
  "Drop Yard",
  "Return Container",
  "Total Driver Pay",
  "Total Miles",
  "Total Hours",
  "Total Days",
  "Loads/Day",
  "Rev/HR",
  "Revenue",
  "%",
  "Stand by Time",
  "Driver Effiency ",
];

const tableData = [];
for (let i = 0; i < 20; i++) {
  tableData.push({
    driver: "Devon Lane",
    customerName: "Jenny Wilson",
  });
}

const options = [
  { value: "jessica.hanson@example.com", label: "jessica.hanson@example.com" },
  { value: "john.doe@example.com", label: "john.doe@example.com" },
  { value: "alex@example.com", label: "alex@example.com" },
];

const StaticTableContent = () => {
  return (
    <React.Fragment>
      <div
        className="table-responsive"
        style={{ height: "calc(100vh - 260px)" }}
      >
        <table className="table table-card table-card--ls">
          <thead>
            <tr>
              {columns.map((column) => {
                return (
                  <th scope="col" key={column}>
                    {column}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {tableData.map((tdata) => {
              return (
                <tr key={tdata.id}>
                  <td>
                    <div class="d-flex">
                      <div class="mr-2 align-self-center">
                        <div class="avatar-circle avatar bg-gray-100">
                          <div class="avatar-circle__initial ">DL</div>
                        </div>
                      </div>
                      <h5 class="mb-0 align-self-center">
                        <a href="#" class="text-dark">
                          {tdata.driver}
                        </a>
                      </h5>
                    </div>
                  </td>
                  <td>{tdata.customerName}</td>
                  <td>11</td>
                  <td>4</td>
                  <td>7</td>
                  <td>7</td>
                  <td>7</td>
                  <td>7</td>
                  <td>$739.65</td>
                  <td>2860.75</td>
                  <td>01.37</td>
                  <td>12</td>
                  <td>12</td>
                  <td>12</td>
                  <td>$739.65</td>
                  <td>3.69</td>
                  <td>27.95</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </React.Fragment>
  );
};

export default StaticTableContent;
